import { useState } from "react";
import useSWR from "swr";

export default function useGetTrackPackage(trackingNumber) {
  const [trackingData, setTrackingData] = useState(null);

  const isValidTracking =
    trackingNumber !== null &&
    trackingNumber !== undefined &&
    trackingNumber !== "Not Available";
  const cleanedOutTracking = trackingNumber
    ? trackingNumber.replace(/[^0-9]/g, "")
    : null;
  const { data } = useSWR(
    isValidTracking
      ? `https://package.place/api/track/${cleanedOutTracking}`
      : null,
    {
      onSuccess: (data) => {
        const firstEntry = Object.entries(data)[0][1];
        setTrackingData(firstEntry);
      },
      onError: (err) => {
        console.error("Error fetching tracking data:", err);
      },
    },
  );

  let name,
    id = null;
  const lastStatus =
    trackingData?.length > 0
      ? trackingData[trackingData.length - 1].status
      : null;
  if (lastStatus) {
    if (lastStatus.toLowerCase().includes("delivered")) {
      name = "Delivered";
      id = 9;
    } else if (
      lastStatus.toLowerCase().includes("delivery") ||
      lastStatus.toLowerCase().includes("transit")
    ) {
      name = "Out for Delivery";
      id = 8;
    } else if (lastStatus.toLowerCase().includes("ship")) {
      name = "Shipped";
      id = 7;
    }
  }

  return {
    tracking: {
      trackingData,
      status: {
        name,
        id,
      },
    },
  };
}
